import React, { useState }  from 'react';
import { Modal }            from "react-bootstrap";

import arrow                    from 'images/definitive/icn-arrow-forward.png';

export default function HowToGetQudoButton() {
    const [modalShow, setModalShow] = useState(false)

    function modal() {
        return(
            <>
            <Modal show={modalShow} onHide={() => setModalShow(false)}>
                <Modal.Header closeButton className='modal-header-position'/>

                <div className="row" style={{height: "100%", overflow: "hidden"}}>
                    <div className="col-12">
                        <div className="mx-auto gamedetails-image-container" style={{padding: 0}}>
                            <div className="mb-4 mt-5">
                                <div className="section-title text-center">How to get QUDO</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-11 mb-5 mx-auto" style={{overflow: "auto"}}>
                        <div className="mb-3">
                            Since QUDO is still on a test net, current QUDO tokens are test tokens with no market value. 
                            QUDO is anticipated to go live on the main net very soon. QUDO token price 
                            will be determined by market dynamics when launched in the main net.
                        </div>
                        <div className="mb-3">
                            We successfully finished the QUDO tokens seed round, and the private sale is already underway. 
                            If you want to be eligible for the token private sale or if you have any questions, please 
                            contact us at

                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="mailto:qudo.token@blockbastards.io"
                                className="d-inline-block mx-1"
                            >
                                qudo.token@blockbastards.io.
                            </a>
                        </div>
                        <div>
                            You can also join the upcoming public token sale by subscribing to the QUDO whitelist to be 
                            among the first ones to receive access to the QUDO public sale. Meanwhile, we highly advise 
                            you to join our

                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://discord.gg/SwmdFkMhhe"
                                className="d-inline-block mx-1"
                            >
                                Discord
                            </a>

                            and

                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://t.me/qudocoin"
                                className="d-inline-block mx-1"
                            >
                                Telegram
                            </a>

                            channels as it will be where we will announce the QUDO whitelist and to remain up to date.
                        </div>
                    </div>  
                </div>
            </Modal>
            </>
        );
    }

    return(
        <div className="w-100">
            <button id="qudoinfobtn" onClick={() => setModalShow(true)}>
                HOW TO <b>GET</b> QUDO?
                <img style={{float: "right"}} src={arrow} alt="arrow"/>
            </button>

            {modal()}
        </div>
    );
}